/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FinalizeDisputeLostRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {FinalizeDisputeLostResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const finalizeDisputeLost = (request: FinalizeDisputeLostRequest, options?: CashRequestOptions) => post<FinalizeDisputeLostRequest, FinalizeDisputeLostResponse>("/2.0/cash/finalize-dispute-lost", request, {...options, rejectOnError: true })